export enum FeatureFlagKey {
  HideInPersonAmex = "hideInPersonAmex",
  HideUnreleasedAcquirers = "hideUnreleasedAcquirers",
}

export enum FeatureFlagSource {
  Registry = "registry",
  Database = "database",
}

export interface IResolvedFeatureFlag {
  enabled: boolean;
  value: unknown;
  description: string;
  source: FeatureFlagSource;
}

export type IFeatureFlagMap = Record<string, IResolvedFeatureFlag>;
